import React, { useEffect } from 'react'

import './joinNewsletterForm.css'

const JoinNewsletterForm = () => {
  useEffect(() => {
    const script = document.createElement('script')

    script.src = '//js.hsforms.net/forms/embed/v2.js'
    document.body.appendChild(script)

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          cssClass: 'hs-form--inline',
          portalId: '4284310',
          formId: '121a18ef-7c70-4286-986a-b98bcdad9a67',
          target: '#hsJoinNewsletterForm'
        })
      }
    })
  }, [])

  return (
    <div className="flex flex-col lg:flex-row">
      <span className="leading-9 mr-4">Join our Newsletter</span>
      <div id="hsJoinNewsletterForm" className="flex" />
    </div>
  )
}

export default JoinNewsletterForm
